import BikeIcon from "../images/bike-icon.svg";
import EasySwapBike from "../images/easy-swap-bike.svg";
import RepairIcon from "../images/repair-icon.svg";
import Available from "../images/available.svg";

const PerksData = [
  {
    id: 1,
    image: BikeIcon,
    text: "Your own bike",
  },
  {
    id: 2,
    image: RepairIcon,
    text: "Repairs included",
  },
  {
    id: 3,
    image: Available,
    text: "Available 24*7",
  },
  {
    id: 4,
    image: EasySwapBike,
    text: "Easy bike swap",
  },
];

export default PerksData;
